<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #layoutContent>
      <div class="card">
        <Loader>
          <div class="d-flex flex-column-fluid">
            <div class="container">
              <div class="card card-custom" >
                <div class="card-header py-3">
                  <div class="card-title align-items-start flex-column">
                    <h3 class="card-label font-weight-bolder text-dark"> {{$t('setting.notices')}}</h3>
                    <span class="fs-3 text-muted">{{ $t("setting.notice_helper_text") }}</span>
                  </div>
                  <div class="card-toolbar"></div>
                </div>

                <div class="card-body mb-10" style="background-color: #0072CE0D;">
                  <form class="form mb-4" v-for="(module, index) in moduleNotices" :key="index">
                    <h5 class="card shadow-sm p-3" style="width: 220px;">{{ module['title_'+locale] }} </h5>
                    <div class="row">
                      <div class="form-group col-12 col-md-6 col-lg-6" v-for="(notice, key) in module.notices" :key="key">
                        <div class="card shadow-sm p-3 col-12 mb-4">
                          <div class="row">
                            <label class="col-10 col-form-label">{{notice['title_'+locale] }}</label>
                            <div class="col-2 switch-btn mt-3">
                            <span class="switch switch-icon">
                              <label>
                                <div class="form-check form-switch form-check-custom form-check-solid">
                                  <input
                                      class="form-check-input h-20px w-30px"
                                      type="checkbox"
                                      :name="notice.value"
                                      :value="notice.id"
                                      v-model="notice.enabled"
                                      @change="allowReceiveNotice(notice.enabled, notice.id)"
                                      id="flexSwitchChecked"
                                  />
                                </div>
                              </label>
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Loader>
      </div>
    </template>
  </SubLayout>

</template>
<script setup>
import Loader from '@/components/Loader.vue'
import { useLocales } from '@/composables/locales'
import { computed, onMounted } from 'vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";


const route = useRoute()
const store = useStore()
const {locale} = useLocales()

const role = ref({})
const loading = ref(false)
const modules = ref([])
const title = ref(i18n.global.t('menu.settings'))
const breadcrumbs = ref([
  {
    name: i18n.global.t('setting.notices'),
    path: '/'
  }
])

const moduleNotices = computed(() => store.getters['notice/getModuleNotices'])


onMounted(async() => {
  await store.dispatch("notice/loadNotices")
})


    
async function allowReceiveNotice(val, name) {
  let data = {enabled: val, notice: name}
  await store.dispatch("notice/receiveNotice",data)
  window.toastr['success'](i18n.global.t("notification.notice_added"))
}
  

</script>

<style scoped>
th,td {
  color: #181c32 !important;
  font-size: 14px;
}
.switch-btn{
  margin-top: 10px;
}
</style>